<template>
  <div class="md-layout-item md-xsmall-size-100 md-medium-size-50 md-size-33 card-margin-top">
    <md-card class="md-card-stats">
      <md-card-header :data-background-color="dataBackgroundColor">
        <i class="material-icons">
          <slot name="icon"></slot>
        </i>
      </md-card-header>

      <md-card-content>
        <p class="category">
          <slot name="title"></slot>
        </p>
        <h3 class="title">
          <slot name="value"></slot>
        </h3>
      </md-card-content>
    </md-card>
  </div>


</template>
<script>
  export default {
    name: 'stats-card',
    props: {
      size: {
        default: 33,
      },
      dataBackgroundColor: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style scoped>
.card-margin-top {
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/StatCard.vue